import React from "react";
import ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Service worker registration is intentionally OFF (see service-worker.js for why —
// the old version cache-first'd index.html forever under a cache name that never
// changed, so new deploys silently never showed up). If an old worker from a
// build before this was disabled is still installed on this device, it keeps
// running and keeps intercepting fetches even though nothing here re-registers
// it — so proactively unregister anything already active and clear its caches
// on every load. This is a one-time cleanup; once every device has loaded this
// once, it can be removed.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  if ('caches' in window) {
    caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
  }
}